import { render, staticRenderFns } from "./ParsersTable.vue?vue&type=template&id=2ee005c0"
import script from "./ParsersTable.vue?vue&type=script&lang=js"
export * from "./ParsersTable.vue?vue&type=script&lang=js"
import style0 from "./ParsersTable.vue?vue&type=style&index=0&id=2ee005c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports